// Module
var code = "<hero-customizer-v2-image-gallery group=\"group\" on-close=\"onClose()\" images=\"images\"></hero-customizer-v2-image-gallery>";
// Exports
module.exports = code;